var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuppManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "white",
    color: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7408 3.66098L8.7408 0.699489C8.66697 0.655748 8.58407 0.632812 8.4998 0.632812C8.41554 0.632812 8.33264 0.655748 8.25881 0.699489L3.25884 3.66098C3.18045 3.70746 3.11508 3.77575 3.06955 3.85872C3.02402 3.94168 3 4.03629 3 4.13266C3 4.22904 3.02402 4.32364 3.06955 4.40661C3.11508 4.48958 3.18045 4.55787 3.25884 4.60435L7.99981 7.41238V13.1841L6.48182 12.2848L5.99982 13.2277L8.25881 14.5657C8.33261 14.6096 8.41552 14.6326 8.4998 14.6326C8.58409 14.6326 8.667 14.6096 8.7408 14.5657L13.7408 11.6042C13.8192 11.5578 13.8846 11.4895 13.9301 11.4065C13.9757 11.3236 13.9997 11.2289 13.9998 11.1325V4.13266C13.9997 4.03627 13.9757 3.94166 13.9301 3.85869C13.8846 3.77572 13.8192 3.70744 13.7408 3.66098ZM8.4998 1.78609L12.4623 4.13266L8.4998 6.47924L4.53733 4.13266L8.4998 1.78609ZM12.9998 10.8143L8.9998 13.1835V7.41184L12.9998 5.04265V10.8143Z",
    fill: "#103A5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99997 7.63159H0V6.55469H3.99997V7.63159ZM4.99996 11.9392H0.999993V10.8623H4.99996V11.9392ZM5.99996 9.7854H1.99999V8.7085H5.99996V9.7854Z",
    fill: "#103A5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppManagement);
export default __webpack_public_path__ + "static/media/supp-management.6161974d7b8b6e79aad386712d437649.svg";
export { ForwardRef as ReactComponent };